import type { FinData } from 'partner360/entities/pbmDashboard'

import type { SobQuarterKey, SobQuarterPolicies } from './types'

export const SOB_QUARTER_KEYS = ['q1', 'q2', 'q3', 'q4'] as const satisfies readonly SobQuarterKey[]
export const OVERALL_SUB_CATEGORY = 'jbp-overall'

export const DEFAULT_CY_QUARTER_POLICIES: SobQuarterPolicies = {
  q1: 'optional',
  q2: 'optional',
  q3: 'optional',
  q4: 'optional',
}

export const DEFAULT_PY_QUARTER_POLICIES: SobQuarterPolicies = {
  q1: 'required',
  q2: 'required',
  q3: 'required',
  q4: 'required',
}

export const PREVIOUS_YEAR_SOB_PLAN_FIELD_BY_QUARTER: Record<SobQuarterKey, keyof FinData> = {
  q1: 'SobPlanPYQ1',
  q2: 'SobPlanPYQ2',
  q3: 'SobPlanPYQ3',
  q4: 'SobPlanPYQ4',
}

export const CURRENT_YEAR_SOB_PLAN_FIELD_BY_QUARTER: Record<SobQuarterKey, keyof FinData> = {
  q1: 'SobPlanCYQ1',
  q2: 'SobPlanCYQ2',
  q3: 'SobPlanCYQ3',
  q4: 'SobPlanCYQ4',
}
